import React, { useState, useEffect } from 'react';
import './ClockTimePicker.css';

const ClockTimePicker = ({ value, onChange, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedHour, setSelectedHour] = useState('');
  const [selectedMinute, setSelectedMinute] = useState('');

  useEffect(() => {
    if (value) {
      const [hour, minute] = value.split(':');
      setSelectedHour(hour || '');
      setSelectedMinute(minute || '');
    }
  }, [value]);

  const hours = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  const minutes = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));

  const handleHourSelect = (hour) => {
    setSelectedHour(hour);
    const newTime = `${hour}:${selectedMinute || '00'}`;
    onChange(newTime);
  };

  const handleMinuteSelect = (minute) => {
    setSelectedMinute(minute);
    const newTime = `${selectedHour || '00'}:${minute}`;
    onChange(newTime);
  };

  const handleInputClick = () => {
    setIsOpen(!isOpen);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div className="clock-time-picker">
      <input
        type="text"
        value={value}
        onClick={handleInputClick}
        placeholder={placeholder}
        readOnly
        className="time-input"
      />
      
      {isOpen && (
        <div className="time-picker-dropdown">
          <div className="time-picker-header">
            <span>დროის არჩევა</span>
            <button onClick={handleClose} className="close-btn">×</button>
          </div>
          
          <div className="time-picker-content">
            <div className="time-column">
              <div className="column-header">საათი</div>
              <div className="time-list">
                {hours.map(hour => (
                  <div
                    key={hour}
                    className={`time-item ${selectedHour === hour ? 'selected' : ''}`}
                    onClick={() => handleHourSelect(hour)}
                  >
                    {hour}
                  </div>
                ))}
              </div>
            </div>
            
            <div className="time-separator">:</div>
            
            <div className="time-column">
              <div className="column-header">წუთი</div>
              <div className="time-list">
                {minutes.map(minute => (
                  <div
                    key={minute}
                    className={`time-item ${selectedMinute === minute ? 'selected' : ''}`}
                    onClick={() => handleMinuteSelect(minute)}
                  >
                    {minute}
                  </div>
                ))}
              </div>
            </div>
          </div>
          
          <div className="time-picker-footer">
            <button onClick={handleClose} className="done-btn">
              დასრულება
            </button>
          </div>
        </div>
      )}
      
      {isOpen && <div className="time-picker-overlay" onClick={handleClose}></div>}
    </div>
  );
};

export default ClockTimePicker;